export const questions =[
    {
        qn: 'Where do you have pain?',
        ansType: 'sketch'
    },
    {

        qn: 'How long have you had your current pain problem?',
        ansType: 'radio',
        choices: ['0-1 weeks', '1-2 weeks', '3-4 weeks', '4-5 weeks', '6-8 weeks', '9-11 weeks', '3-6 months', '6-9 months', '9-12 months', 'over 1 year']
    }, {
        qn: 'How would you rate the pain that you have had during the past week?',
        ansType: 'slider',
        least:'No pain',
        most:'As bad as it could be'
    }, {
        qn: 'I can do light work for an hour.',
        ansType: 'slider',
        least:'Cannot do it because of pain',
        most:'Can do it without pain'
    }, {
        qn: 'I can sleep at night',
        ansType: 'slider',
        least:'Cannot do it because of the pain',
        most:'Can do it without pain'
    },
   
    {
        qn: 'How much have you been bothered by feeling depressed in the past week?',
        ansType: 'slider',
        least:'Not at all',
        most:'Extremely'
    },
   
    {
        qn: 'How tense or anxious have you felt in the past week?',
        ansType: 'slider',
        least:'Absolutely calm and relaxed',
        most:'As tense and anxious as I’ve ever felt'
    },
    {
        qn: 'In your view, how large is the risk that your current pain may become persistent?',
        ansType: 'slider',
        least:'No risk',
        most:'Very large risk'
    }, {
        qn: 'In your estimation, what are the chances you will be working your normal duties in 3 months',
        ansType: 'slider',
        least:'No chance',
        most:'Very large chance'
    }, {
        qn: 'An increase in pain is an indication that I should stop what I’m doing until the pain decreases.',
        ansType: 'slider',
        least:'Completely disagree',
        most:'Completely agree'
    }, {
        qn: 'I should not do my normal work with my present pain.',
        ansType: 'slider',
        least:'Completely disagree',
        most:'Completely agree'
    },]